import type { FaireProductEntity } from "../../entity_types/product";

export const p_qk9k6an32v: FaireProductEntity = {
  token: "p_qk9k6an32v",
  type: "product",
  name: "Amos Peelerz Pineapple 6 oz ",
  brandName: "Cow Crack Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/e120d697b4ea8460184136e2cb23c52a2e2c5db727a1506c4469ef4ab50c4938.png",
  priceDollars: 2.99,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/bc31e1983db8a686d310c4e3dae02aa0ad8d061c5365b58aace5508c29e7fa4e.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
